import styled from 'styled-components'
import { Button } from '../../../components/shared/StyledComponents'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.md};
  margin-top: ${({ theme }) => theme.spacing.lg};
`

const PageInfo = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.textMuted};
`

interface FeedPaginationProps {
    total: number
    limit: number
    offset: number
    onChange: (offset: number) => void
}

export const FeedPagination: React.FC<FeedPaginationProps> = ({ total, limit, offset, onChange }) => {
    const currentPage = Math.floor(offset / limit) + 1
    const totalPages = Math.max(1, Math.ceil(total / limit))
    const hasPrev = offset > 0
    const hasNext = offset + limit < total

    if (total <= limit) return null

    return (
        <Container>
            <Button
                variant="secondary"
                size="sm"
                disabled={!hasPrev}
                onClick={() => onChange(Math.max(0, offset - limit))}
            >
                ← Anterior
            </Button>
            <PageInfo>
                Página {currentPage} de {totalPages} · {total} resultados
            </PageInfo>
            <Button
                variant="secondary"
                size="sm"
                disabled={!hasNext}
                onClick={() => onChange(offset + limit)}
            >
                Siguiente →
            </Button>
        </Container>
    )
}

export default FeedPagination
